<template>
  <div class="item-container">
        <div>
          <h5>{{clinicName}}</h5>
          <p class="border-bottom label-address-font">{{clinicAddress}}</p>

          <p class="clinic-tel" v-if="clinicNumber">Tel : {{ clinicNumber }}</p>
        </div>
      <div>
        <h6>{{medName}}
            <span v-if="medQty || medUnit">&nbsp;-&nbsp;{{medQty}}&nbsp;{{medUnit}}</span>
          </h6>
        <h6 v-html="medDosageValue"></h6>
      </div>
      <div>
        <p class="precaution-font2">{{medPrecautionOne || ''}}</p>
        <p class="precaution-font2">{{medPrecautionTwo || ''}}</p>
        <p class="precaution-font">{{medStrength}}</p>
      </div>
      <div class="flex-container footer">
        <div class="print-med-patient-name med-patient-name">
          <h6 :class="{'long-patientInfo': isPatientInfoLong}">{{patientName}} / {{patientNric}}</h6>
          <h6 :class="{'long-patientInfo': isPatientInfoLong}">DOB: {{patientDetails && patientDetails.dateOfBirth | ddMonthYYYY}}</h6>
        </div>
        <div class="text-right print-med-date med-date">
          <h6>{{new Date() | ddMonthYYYY}}</h6>
        </div>
      </div>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import dateformatter from '@/components/mixins/dateformatter';
import { mapGetters } from 'vuex';

export default {
  name: 'MedicalLabelNiks',
  mixins: [dateformatter],
  props: ['clinicName', 'clinicAddress', 'medName', 'medStrength', 'medQty', 'medDosage', 'medUnit',
    'medExpiry', 'medPrecautionOne', 'medPrecautionTwo', 'patientName', 'patientNric',
    'selectedBatch', 'disableAutoPrint', 'clinicNumber', 'patientDetails', 'description',
  ],
  methods: {
    getExpiry(expiryDate) {
      return this.inventoryExpiryDateFormat(expiryDate);
    },
  },
  computed: {
    ...mapGetters('print', ['setting']),
    ...mapGetters('config', ['featureFlags']),
    medicalLabelHeight() {
      if (localStorage.getItem('printSetup')) {
        return JSON.parse(localStorage.getItem('printSetup')).medicalLabelHeight;
      }
      return 200;
    },
    medDosageValue() {
      return this.medDosage === 'null   null' ? '' : this.medDosage;
    },
    withSelectedBatch() {
      return !_.isEmpty(this.selectedBatch);
    },
    isPatientInfoLong() {
      const patientInfo = `${this.patientName} / ${this.patientNric}`
      return patientInfo.length > 23;
    }
  },
  mounted() {
    if (!this.disableAutoPrint) {
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  },
};
</script>

<style scoped lang="scss">
.precaution-font{
  font-size: 0.9rem;
}
p, h1, h2, h3, h4, h5, h6{
  margin-bottom:0
}
.precaution-font2{
  font-size: 0.8rem;
  line-height: 16px;
}

.long-patientInfo {
  font-size: 0.8rem !important
}
.label-address-font{
  font-size: 0.75rem;
  font-family: 'News Cycle, Arial Narrow Bold, sans-serif' !important
}

.border-bottom{
  border-bottom: 1px solid #000000 !important
}
.flex-container {
  display: flex !important;
  justify-content: space-between;
}
.med-patient-name
{
  flex-basis: 70%;
}

.footer {
  padding: 1em 0 0 0;
  bottom: 0;
  width: 99%;
  position: absolute;
}
.item-container {
  width: 80mm;
  height: 40mm;
  position: relative;
  color: #000;
}

@page {
  margin: 0 !important;
  padding: 0 !important;
  size: 80mm 40mm;
}
</style>

<style lang="scss" scoped>
@media print {
  .item-container  {
    zoom: 1.32 !important;
    margin: 0 !important;
    padding-top: 0.2em !important;
    color: #000 !important;
  }
}
</style>
